import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    dashboardCard: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    cardSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    vendorLinkForm: {
        marginTop: theme.spacing(3),
    },
    vendorSelector: {},
    vendorLinkButton: {
        marginTop: theme.spacing(2),
    },
    validationReportErrorBox: {
        borderTop: '4px solid #d32f2f',
        padding: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        backgroundColor: '#FAEAEA',
        marginBottom: theme.spacing(2),
    },
    validationReportErrorHeading: {
        color: '#d32f2f',
    },
    validationReportSuccessBox: {
        borderTop: '4px solid #4caf50',
        padding: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        marginBottom: theme.spacing(2),
        backgroundColor: '#EDF7ED',
    },
    validationReportSuccessHeading: {
        color: '#2e7b32',
    },
}));
